
export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Atom.HoneyPot';